<template>
  <div>
    <ul class="list-unstyled">
      <li>
        <WCProductHealthAttributes
          :itemAttributes="item.attributes"
          v-if="item.attributes && item.attributes.length > 0"
        />
      </li>
      <li class="location" v-if="item.location">
        <span>{{ $t('location') }}:</span> {{ item.location }}
      </li>
      <li class="upc">
        <span>{{ $t('upc') }}:</span> {{ item.scanCode }}
      </li>
      <li class="brand" v-if="item.brand">
        <span>{{ $t('brand') }}:</span>
        <router-link
          class="underline-link-from-center"
          :to="`/b?g=BRD-${item.brandId}`"
          :aria-label="`${$t('brand')} ${item.brand}`"
        >
          {{ item.brand }}
        </router-link>
      </li>
      <li class="size" v-if="item.size">
        <span>{{ $t('size') }}:</span> {{ item.size }}
      </li>
      <li class="region" v-if="item.regionalDescriptor">
        <span>{{ $t('region') }}:</span> {{ item.regionalDescriptor }}
      </li>
      <li class="item-method" v-if="item.productionMethod">
        <span>{{ $t('productMethod') }}:</span> {{ item.productionMethod }}
      </li>
      <li class="loyalty" v-if="item.loyalty > 0">
        <span>{{ $configuration.loyaltyName }}*:</span>
        {{ item.loyalty }}
      </li>
      <li class="stock" v-if="item.availability">
        <span>{{ $t('availability') }}:</span>
        <strong v-if="item.availability === 'low'" class="low">{{
          $configuration.limitedAvailabilityTerm
        }}</strong>
        <strong v-if="item.availability === 'showQuantity'" class="low">
          {{ item.onHand }} {{ $configuration.inStockTerm }}</strong
        >
        <strong v-if="item.availability === 'high'" class="high">{{
          $configuration.inStockTerm
        }}</strong>
        <strong v-if="item.availability === 'order'" class="order">{{
          $configuration.onOrderTerm
        }}</strong>
        <strong v-if="item.availability === 'out'" class="out">{{
          $configuration.outOfStockTerm
        }}</strong>
      </li>
      <li class="payment-options d-flex" v-if="specialTenders">
        <span>{{ $t('specialPaymentOptions') }}:</span> {{ specialTenders }}
      </li>
      <li class="pack-size" v-if="item.ascQuantity != 1">
        <span>{{ $t('packSize') }}:</span> {{ item.ascQuantity }}
      </li>
      <li class="local" v-if="item.local">
        <span>{{ $t('local') }}:</span>{{ $t('locallySourced') }}
      </li>
      <li class="pt-3" v-if="custom">
        <WCCustomContent :content="custom.content" />
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import WCProductHealthAttributes from '../WCProductHealthAttributes/WCProductHealthAttributes.vue';
import WCCustomContent from '../WCCustomContent/WCCustomContent.vue';

export default defineComponent({
  components: {
    WCProductHealthAttributes,
    WCCustomContent,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    custom: {
      type: Object,
    },
  },
  computed: {
    specialTenders() {
      return this.item.specialTenders?.map(specialTender => specialTender.name)?.join(', ');
    },
  },
});
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.attributes {
  .attribute {
    display: inline-block;
    height: rem(30px);
    padding: calc($pad-1 / 2);
  }
}

ul li span {
  min-width: rem(180px);
  float: left;
}
</style>
